export const SET_ERROR = 'GOLDEN_CHIPS_BALANCES:SET_ERROR';
export const TOGGLE_LOADING = 'GOLDEN_CHIPS_BALANCES:TOGGLE_LOADING';
export const SET_GOLDEN_CHIPS = 'GOLDEN_CHIPS_BALANCES:SET_GOLDEN_CHIPS';
export const SET_BONUS_DETAILS = 'GOLDEN_CHIPS_BALANCES:SET_BONUS_DETAILS';

export const setGoldenChips = (goldenChipsBalances) => ({
    type: SET_GOLDEN_CHIPS,
    payload: goldenChipsBalances
});

export const setBonusDetails = ({ id, bonusDetails, isLoading, error }) => ({
    type: SET_BONUS_DETAILS,
    payload: { id, bonusDetails, isLoading, error }
});

export const toggleLoading = (isLoading) => ({
    type: TOGGLE_LOADING,
    payload: isLoading
});

export const setError = ({ error }) => ({
    type: SET_ERROR,
    payload: { error }
});
